import type { EarlyLoanRepaymentFeatureConfig } from '../../../types/features/EarlyLoanRepaymentFeatureConfig';

export const earlyLoanRepayment: EarlyLoanRepaymentFeatureConfig = {
    preloadRepaymentOptions: false,
    isFullRepaymentPossible: true,
    summary: {
        showSubtitle: true,
        showSubtitleWhatPointsToElectronicStorage: false,
        showExtraordinaryRepaymentMessage: true,
        showLoanNumber: false,
        showPaidFromAccount: false,
        showCurrentInstalment: false,
        showFaqSection: true,
        showDocumentDownload: false,
        showFees: true,
        showSimplifiedFees: false,
        showCurrentMaturityDate: false,
        showNextMaturityDate: false,
        showNextInstallmentDateFromAccountResponse: true,
        showNextInstallmentDateFromRepaymentInfoResponse: false,
        showNextInstallmentAmount: true,
        showNewInstallmentAmount: false,
        showRemainingInstallmentsBeforeReimbursement: true,
        showRemainingInstallmentsAfterReimbursement: true,
        showShortenedInstallments: true,
        showInstallmentFrequency: false,
        showRemainingInstallments: true,
        showCurrentDueDate: true,
        showNewDueDate: true,
        showCurrentLoanBalance: true,
        showNewLoanBalance: true,
        showPaidInterest: true,
    },
    amountInput: {
        showFeesMessage: true,
        showPossibleAmountRangeInfo: false,
    },
    inputValidation: {
        overTheMaximumKey: 'products.loanRepayment.maximumTextTotalRepayment',
    },
    errorScreen: {
        showPhoneSupportError: true,
        showAMLSuspectError: true,
        conditionNotMetKey: 'products.loanRepayment.errorConditionsNotMetRo',
        amlSuspectKey: 'products.loanRepayment.amlSuspectErrorRo',
    },
    adjustLoan: {
        showTooShortPeriodMessage: true,
        showInfoMessageAboutSpecificLoanRepayment: true,
        showInfoMessageAboutHigherPayment: false,
    },
};
